import { createSelector } from 'reselect';
import { State } from 'reducers';
import { DeviceId } from 'types';
import { initialTimelineState, TimelineState } from 'reducers/timelineReducer';

export type HasDeviceId = {
    deviceId: DeviceId | null;
};

const getDeviceId = <T extends HasDeviceId>(state: State, { deviceId }: T) => deviceId;

const getTimelineState = (state: State) => state.timeline;

const getDeviceTimelineState =
    createSelector(
        getTimelineState,
        getDeviceId,
        (timelines, deviceId) => deviceId && timelines[deviceId] || initialTimelineState
    );

export const isLoadingTimeline =
    createSelector(
        getDeviceTimelineState,
        (state: TimelineState) => state.loading
    );

export const getTimelineError =
    createSelector(
        getDeviceTimelineState,
        (state: TimelineState) => state.error
    );

export const getTimelineMessages =
    createSelector(
        getDeviceTimelineState,
        (state: TimelineState) => state.messages
    );

export const getTimelineMessagesDate =
    createSelector(
        getDeviceTimelineState,
        (state: TimelineState) => state.utcDate
    );



// WEBPACK FOOTER //
// ./src/selectors/timelineSelectors.ts